export default {"src":"/_next/static/media/social-media.8990bb5b.svg","height":681,"width":681,"blurWidth":0,"blurHeight":0};